// extracted by mini-css-extract-plugin
export var discard = "_4y-3";
export var muiTooltipTooltip = "_4y-5";
export var notificationBar = "_4y-2";
export var saveButtonHoverSlotWrapper = "_4y-4";
export var show = "_4y-1";
export var spacer = "_4y-0";